import script from "./PricingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PricingPage.vue?vue&type=script&lang=ts&setup=true"

import "./PricingPage.vue?vue&type=style&index=0&id=35066d0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35066d0f"]])

export default __exports__